import { gql } from "generated-graphql";

export const GET_STAFF_CERS_ANALYTICS = gql(/* GraphQL */ `
  query StaffCersAnalytics($tenantId: ID) {
    staffCersAnalytics(tenantId: $tenantId) {
      windowStart
      windowEnd
      trend {
        month
        decided
        substantiveRejections
        ratePct
      }
      byTenant {
        tenantId
        tenantName
        facilities
        decided
        substantiveRejections
        ratePct
      }
      byCupa {
        cupaCode
        displayName
        decided
        substantiveRejections
        ratePct
      }
      byModule {
        module
        decided
        substantiveRejections
        ratePct
      }
      byIssueCategory {
        category
        count
        pctOfSubstantive
      }
    }
  }
`);
